<template>
  <div
    :class="style.loader"
    role="status"
    aria-label="Загрузка"
    aria-live="polite"
  >
    <span aria-hidden="true" />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./LoaderComponent.module.scss";

export default defineComponent({
  name: "LoaderComponent",

  data() {
    return {
      style
    };
  }
});
</script>
